var SylController = /** @class */ (function () {
    function SylController(editor, props) {
        this.name = ''; // format name
        this.toolbar = {};
        this.props = {};
        this.editor = editor;
        this.props = props;
    }
    SylController.prototype.editorWillUnmount = function () {
        // destroy virtual function
    };
    return SylController;
}());
export { SylController };
//# sourceMappingURL=controller.js.map